import { Link } from "react-router-dom";

const COLUMNS = [
  {
    heading: "Explore",
    links: [
      ["App Description", "/about.html"],
      ["Premium", "/premium-subscriptions.html"],
      ["Download Mobile App", "/download.html"],
    ],
  },
  {
    heading: "Help & Account",
    links: [
      ["Support", "/support.html"],
      ["Contact", "/contact.html"],
      ["Log In", "/login"],
      ["Account Deletion", "/account-deletion.html"],
    ],
  },
  {
    heading: "Trust & Safety",
    links: [
      ["Privacy Policy", "/privacy-policy.html"],
      ["Terms of Service", "/terms-of-service.html"],
      ["Community Guidelines", "/community-guidelines.html"],
      ["Child Safety", "/child-safety.html"],
      ["User Responsibilities", "/users-responsibilities.html"],
    ],
  },
];

const linkClass =
  "inline-block rounded py-1.5 text-[15px] text-emerald-100/80 transition-colors hover:text-white hover:underline underline-offset-4 focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B968] focus-visible:ring-offset-2 focus-visible:ring-offset-emerald-950";

function FooterLink({ label, href }) {
  const slug = label.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  // Internal SPA route uses <Link>; hosted static pages use a normal anchor.
  if (href === "/login") {
    return <Link to={href} data-testid={`footer-link-${slug}`} className={linkClass}>{label}</Link>;
  }
  return <a href={href} data-testid={`footer-link-${slug}`} className={linkClass}>{label}</a>;
}

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-emerald-950 text-emerald-50" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <div className="grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3">
              <img src="/logo_icon.png" alt="Nikah Match" width="48" height="48" className="h-11 w-11 shrink-0 rounded-xl object-cover ring-1 ring-white/15" />
              <span className="font-serif text-2xl font-bold leading-none tracking-wide whitespace-nowrap">
                <span className="text-white">Nikah</span> <span className="text-[#D9B968]">Match</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-[15px] leading-relaxed text-emerald-100/70">
              A serious Muslim marriage platform, built for nikah.
            </p>
          </div>

          {/* Link columns */}
          {COLUMNS.map((col) => (
            <nav key={col.heading} aria-label={col.heading}>
              <h3 className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-[#D9B968]">{col.heading}</h3>
              <ul className="flex flex-col">
                {col.links.map(([label, href]) => (
                  <li key={label}><FooterLink label={label} href={href} /></li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        {/* Copyright */}
        <div className="mt-12 border-t border-white/10 pt-6 text-sm text-emerald-100/60">
          © {year} Nikah Match. All rights reserved. · Horizon Grid LLC
        </div>
      </div>
    </footer>
  );
}
